<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Finance"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        费控系统
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 坐班指纹打卡 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">发票查验及上传报销</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第一步：登陆云办公APP，点击左上角扫码图标，扫描发票二维码验证或拍照上传验证。云办公会自动关联国家税务总局全国增值税发票查验平台对发票进行查验。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第二步：验证成功后可在云办公中查到如下信息。查验过的发票信息会自动上传到验证人的费控系统中，查验人与报销人必须是同一人，否则无法选中此发票，且同一张发票只可验证一次，不可多人同时验证。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">发票查验及上传报销</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第三步：点击【事后费用报销】-【我的发票】-【发票列表】-【通用发票】，可查询到验证过的发票，且发票显示为未报销状态。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第四步：费用报销报销时，在选择发票栏选择相对应的发票即可。</p>
                    <img src="../../assets/7.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {
            var code = this.$route.params.code;
            if (code == 11) {
                this.fingerprintShow = true;
            } else if (code == 12) {
                this.flowShow = true;
            } else if (code == 79) {
                this.agreementShow = true;
            }
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"111"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 15px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30% !important;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Finance/finance5.vue